<template>
  <Article>
    <Heading as="h1">
      <!--  -->
      Tax Credit Financing
    </Heading>
  </Article>
</template>

<script setup>
defineOptions({ name: "ViewTaxExempt" });
import Article from "../components/Article.vue";
import Heading from "../components/Heading.vue";
</script>
